"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  stockBase: {
    common: {
      meterialBaseData: '物资基础数据',
      operation: '操作',
      cancel: '废弃',
      copyAdd: '拷贝新增',
      baseData: '基础数据'
    },
    keyWordFilter: {
      mat: '可查询模板编码、模板名称、模板名称(英文)'
    },
    materialApplyTem: {
      maTemplate: '物资申请模板',
      maTemplateAdd: '物资申请模板新增',
      maTemplateEdit: '物资申请模板编辑',
      company: '公司',
      shipName: '船名',
      applyCategory: '申请类别',
      temCode: '模板编码',
      tempName: '模板名称(中文)',
      tempNameEN: '模板名称(英文)',
      creator: '创建人',
      createDept: '创建部门',
      state: '状态',
      remark: '备注',
      unEffective: '未提交',
      effective: '已提交',
      voided: '作废',
      allTemp: '全部',
      sequence: '顺序码',
      IMPACode: 'IMPA代码',
      materiaName: '物资名称',
      materialSize: '物资规格',
      unit: '单位',
      dAQty: '默认申请数量',
      baseInfo: '基本信息',
      fileInfo: '附件信息',
      mtrMsg: '物资信息',
      spanContent: '色数字：申请数量与定单数量不一致',
      chooseAppMtr: '选择申请物资',
      material: '物资',
      rules: {
        companyReq: '请选择公司',
        typeReq: '请选择类别'
      }
    },
    purchaseHome: {
      spsManage: '备件管理',
      mtrManage: '物资管理',
      urgentNum: '紧急',
      orderTracking: '定单跟踪',
      supplierName: '供应商名称',
      logtName: '物流商名称',
      ateTime: '预计送货时间',
      atePort: '预计送货港口',
      orderNum: '定单号',
      payState: '付款状态',
      state: '状态',
      budgetPerformance: '预算执行情况',
      annualFleetBbudget: '船队年度预算',
      rBAFleet: '船队剩余预算金额',
      actualUseFleet: '船队实际使用金额',
      notOrderedFleet: '船队未下单金额',
      comparisonAllShip: '所管船舶对比',
      comparisonShip: '船队对比',
      shipName: '船舶名称',
      costSub: '预算科目',
      annualBudget: '预算金额',
      actualUse: '定单金额',
      actualProportion: '预算完成进度',
      notOrderAmount: '未下定单金额',
      payAttentionDoc: '收藏单据',
      docNo: '单据号',
      docType: '单据类型',
      businessMode: '业务模块',
      businessSummary: '业务摘要',
      remark: '备注',
      spsMinStocky: '最低库存预警',
      keyParts: '关键备件',
      optParts: '营运备件',
      monParts: '受控备件',
      items: '(项)',
      optStock: '营运库存',
      notStockyNum: '库存不足数量',
      stockyChange: '库存变化',
      currentDay: '当日',
      sevenDay: '最近七日',
      thirtyDay: '最近30日',
      inStockyNum: '入库次数',
      outStockyNum: '出库次数',
      inventoryMonitor: '最近一次库存盘点',
      inventoryOrderNo: '盘点单号',
      inventoryOrderTime: '盘点时间',
      inventoryGainLoss: '盘盈/盘亏',
      currentState: '当前状态',
      spsMinStockyWarning: '备件最低库存预警',
      index: '序号',
      equipmentMsg: '设备信息',
      spsMsg: '备件信息',
      minStocky: '安全库存',
      currentStocky: '当前库存',
      mtrMinStockyWarning: '物资最低库存预警',
      mtrType: '物资分类',
      mtrMsg: '物资信息',
      drugMsg: '药品信息',
      num: '数量',
      validWaring: '有效期预警',
      category: '类别',
      manufactureDate: '生产日期',
      expirationDate: '过期日期',
      Expired: '距离有效期(天)',
      stockyWarning: '库存盘点预警',
      lastCountDate: '上次盘点日期',
      daysFromLastCount: '距上次盘点天数',
      quickCheck: '快速盘点',
      quickSign: '快速签收',
      spare: '备件',
      material: '物资',
      apply: '申请',
      spsApply: '备件申请',
      mtrApply: '物资申请',
      inOutStocky: '出入库',
      spsInOutStocky: '备件出入库',
      mtrInOutStocky: '物资出入库',
      inventory: '盘点',
      spsInventory: '备件盘点',
      mtrInventory: '物资盘点',
      defectiveMark: '次品标记',
      spsDefectiveMark: '备件次品标记',
      mtrDefectiveMark: '物资次品标记',
      signFor: '签收',
      spsSignFor: '备件签收',
      mtrSignFor: '物资签收',
      addEvaluation: '追加评价',
      spsAddEvaluation: '备件采购追加评价',
      mtrAddEvaluation: '物资采购追加评价',
      flowManagement: '流向管理',
      spsFlowManagement: '备件流向管理',
      mtrFlowManagement: '物资流向管理',
      harmFulList: '在船物资清单',
      spsHarmFulList: '在船备件清单',
      mtrHarmFulList: '在船物资清单',
      spsOrderSignFor: '备件定单签收',
      dept: '部门',
      applyNo: '申请单号',
      equipmentName: '设备名称',
      orderedDate: '下单日期',
      supplier: '供应商',
      logisticsProvider: '物流商',
      mtrOrderSignFor: '物资定单签收'
    },
    locationInfo: {
      locationInfo: '库位信息',
      changeStock: '移库',
      vesselName: '船名',
      parentLocation: '上级库位',
      code: '编号',
      personInCharge: '保管人',
      locationName: '库位名称',
      operator: '操作人',
      locationNameEn: '库位名称(英文)',
      operateDate: '操作日期',
      locationDesc: '库位描述',
      locationDescEn: '库位描述(英文)',
      locationAddTip: '请点击备件库位或物料库位选择需要新增的库位类型'
    },
    materialStock: {
      materialStock: '物资库',
      printBarcode: '打印条码',
      seqNo: '序号',
      materialCode: '物资编号',
      materialType: '物资类别',
      applyType: '申请类别',
      materialName: '物资名称',
      materialNameEn: '物资名称(英文)',
      saveTip: '英文名称+规格型号需唯一',
      spec: '规格型号',
      specEn: '规格型号(英文)',
      unit: '单位',
      status: '状态',
      canApply: '是否可申请',
      safetyFlag: '是否安全费用',
      remark: '备注',
      opt: '操作',
      materialInfo: '物资信息',
      showMaterialInfo: '查看物料详情',
      materialInventoryTips: '查看物资采购历史、物资库存变化历史请先选择船舶',
      manageImage: '管理图片',
      imageManage: '图片管理',
      monitorFlag: '受控项目',
      blindFlag: '需要盲盘',
      criticalFlag: '关键物资',
      harmfulFlag: '包含有害物质',
      proposedPrice: '参考价格',
      proposedPriceCurrency: '参考价格币种',
      vesselSetting: '船舶相关设置',
      filterTip: '可查询船舶代码、船舶名称',
      batchSetting: '批量设置',
      vesselCode: '船舶编号',
      vesselName: '船舶名称',
      oilPurpose: '润滑油用途',
      minStockQty: '安全库存',
      maxStockQty: '最高库存',
      stockSetting: '库存相关设置',
      oilTip: '单个润滑油只有一个用途关联库存，关联库存的润滑油在月报表消耗才会产生出库记录，单个润滑油中的润滑油类型是一致的。',
      addPurpose: '新增用途',
      linkStock: '是否关联库存',
      oilType: '润滑油类型',
      purposeName: '用途',
      tankCapacity: '仓容',
      density: '密度',
      useVessel: '使用船舶',
      vesselNameCn: '船舶名称(中文)',
      vesselNameEn: '船舶名称(英文)',
      uploadImage: '上传图片',
      imageInfo: '图片信息',
      fileName: '附件名称',
      uploadTime: '上传时间',
      sort: '排序',
      sequence: '顺序',
      effective: '已生效',
      all: '全部',
      invalided: '已废弃',
      newStock: '物资信息新增',
      editStock: '物资信息编辑',
      vessel: '船舶',
      purchaseHistory: '物资采购历史',
      stockChange: '物资库存变化',
      companyInfoTip: '请填写公司配置信息',
      companyInfoSelectTip: '请选择公司配置中的公司信息',
      currentMaterialToSave: '当前保存物料信息',
      sameTips1: '保存的物料与下列物料相似，是否确认保存？'
    },
    materialType: {
      materialType: '物资类别',
      materialTypeCode: '物资类别编码',
      parentType: '上级类别',
      sequence: '顺序',
      materialTypeName: '物资类别名称',
      materialTypeNameEn: '物资类别名称(英文)',
      materialTypeDesc: '物资类别描述',
      materialTypeDescEn: '物资类别描述(英文)',
      remark: '备注'
    }
  }
};